/* 361 Sleep theme — product page (sections/pdp-*.liquid): gallery, variant picker, sticky buy bar, page mood.
   Offers, quantity and add to cart are wired by theme.js (bindOffers on [data-buy]). */
(() => {
  const S = window.SITE;
  const page = document.querySelector("[data-pdp]");
  if (!S || !page) return;
  const body = document.body;

  /* page mood (technogel is "cool"); the sections carry it too, so scrolling keeps it */
  if (page.dataset.pdpMood) body.dataset.mood = page.dataset.pdpMood;

  /* ---------- gallery ---------- */
  const stage = document.getElementById("stage"), stageImg = document.getElementById("stageImg"), thumbs = document.getElementById("thumbs");
  function show(src, cover, btn) {
    if (!stage) return;
    if (btn) thumbs.querySelectorAll("button").forEach((x) => x.setAttribute("aria-current", String(x === btn)));
    if (stageImg.getAttribute("src") === src) return;
    stage.classList.remove("zoom"); stage.classList.add("fade");
    setTimeout(() => {
      stageImg.onload = () => stage.classList.remove("fade");
      stageImg.removeAttribute("width"); stageImg.removeAttribute("height");
      stageImg.src = src;
      stageImg.classList.toggle("cover", cover);
      if (stageImg.complete) stage.classList.remove("fade");
    }, 260);
  }
  thumbs?.addEventListener("click", (e) => {
    const b = e.target.closest("button[data-src]"); if (!b) return;
    show(b.dataset.src, b.dataset.cover === "1", b);
  });
  stage?.addEventListener("click", () => stage.classList.toggle("zoom"));
  stage?.addEventListener("pointermove", (e) => {
    if (!stage.classList.contains("zoom")) return;
    const r = stage.getBoundingClientRect();
    stageImg.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
  });

  /* ---------- buy box ---------- */
  const buy = page.querySelector("[data-buy]");
  const addBtn = buy?.querySelector("[data-buy-add]");

  /* variant picker (only rendered when the product has real variants) */
  const vSel = buy?.querySelector("[data-variant-select]");
  vSel?.addEventListener("change", () => {
    const o = vSel.selectedOptions[0];
    Object.assign(buy.dataset, { variantId: o.value, price: o.dataset.price, compare: o.dataset.compare, img: o.dataset.img });
    if (o.dataset.src) show(o.dataset.src, true);
    const ok = o.dataset.available === "true";
    [addBtn, sticky?.querySelector("[data-sticky-add]")].forEach((b) => { if (b) b.disabled = !ok; });
    if (addBtn && buy.dataset.addLabel) addBtn.textContent = ok ? buy.dataset.addLabel : buy.dataset.soldLabel;
    const url = new URL(location.href); url.searchParams.set("variant", o.value); history.replaceState(null, "", url);
    buy._sync?.();
  });

  /* ---------- sticky buy bar: shows once the main button scrolls away, adds the picked offer ---------- */
  const sticky = document.getElementById("stickyBuy");
  if (sticky && addBtn) {
    const sBtn = sticky.querySelector("[data-sticky-add]"), sPrice = sticky.querySelector("[data-sticky-price]");
    sBtn.addEventListener("click", () => addBtn.click());
    buy.addEventListener("offer", (e) => { if (sPrice) sPrice.innerHTML = S.money(e.detail.price); });
    buy._sync?.(); // theme.js already painted the first offer before this listener existed
    let shown = false;
    const check = () => {
      const show = addBtn.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      sticky.classList.toggle("show", show); sticky.setAttribute("aria-hidden", String(!show));
      sBtn.tabIndex = show ? 0 : -1;
    };
    addEventListener("scroll", check, { passive: true });
    check();
  }

  /* ---------- related cards reveal in sequence, as on the static page ---------- */
  document.querySelectorAll("[data-related] .card").forEach((c, i) => { c.setAttribute("data-reveal", ""); c.style.setProperty("--d", `${i * 0.1}s`); });
  S.observe(document);
  S.refresh();
})();
